var render = function render(){
  var _vm$data;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-row', [_c('b-modal', {
    attrs: {
      "title": "".concat(_vm.selectedIndex !== null ? 'Edit' : 'Add', " Sub Contractor"),
      "size": "lg"
    },
    on: {
      "hide": _vm.onHide
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref) {
        var cancel = _ref.cancel;
        return [_c('div', [_c('b-button', {
          staticClass: "mr-2",
          attrs: {
            "variant": "outline-primary"
          },
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v("Cancel & Close")]), _vm.selectedIndex == null ? _c('b-button', {
          staticClass: "mr-2",
          attrs: {
            "variant": "outline-primary"
          },
          on: {
            "click": _vm.addForm
          }
        }, [_vm._v("Add Form")]) : _vm._e(), _c('b-button', {
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.addToList
          }
        }, [_vm._v("Save & Close")])], 1)];
      }
    }]),
    model: {
      value: _vm.showModal,
      callback: function callback($$v) {
        _vm.showModal = $$v;
      },
      expression: "showModal"
    }
  }, [_c('FormSubcon', {
    attrs: {
      "forms": _vm.forms,
      "selectedIndex": _vm.selectedIndex
    }
  })], 1), _vm.createAble ? _c('b-col', {
    staticClass: "mb-3 d-flex justify-content-end",
    attrs: {
      "lg": "12"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "outline-primary",
      "size": "sm"
    },
    on: {
      "click": function click($event) {
        _vm.showModal = true, _vm.selectedIndex = null;
      }
    }
  }, [_vm._v("Add Data Sub Contractor")])], 1) : _vm._e(), _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('div', {
    staticClass: "overflow-auto"
  }, [_c('table', {
    staticClass: "w-100"
  }, [_c('thead', [_c('th', {
    staticClass: "text-nowrap",
    staticStyle: {
      "min-width": "340px"
    }
  }, [_vm._v("Contractor Name")]), _c('th', {
    staticClass: "text-nowrap",
    staticStyle: {
      "min-width": "140px"
    }
  }, [_vm._v("PIC")]), _c('th', {
    staticClass: "text-nowrap",
    staticStyle: {
      "min-width": "140px"
    }
  }, [_vm._v("Email PIC")]), _c('th', {
    staticClass: "text-nowrap",
    staticStyle: {
      "min-width": "140px"
    }
  }, [_vm._v("Phone PIC")]), _c('th', {
    staticClass: "text-nowrap",
    staticStyle: {
      "min-width": "140px"
    }
  }, [_vm._v("Est. Cost")]), _c('th', [_vm._v("Attachment")]), _c('th', [_vm._v("Remarks")]), _vm.createAble ? _c('th', {
    staticClass: "text-nowrap text-center"
  }, [_vm._v("Action")]) : _vm._e()]), _c('tbody', _vm._l(_vm.data, function (item, index) {
    return _c('tr', {
      key: index,
      staticClass: "bg-white"
    }, [_c('td', {
      staticStyle: {
        "min-width": "340px"
      }
    }, [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : item.subkon_name))]), _c('td', [_vm._v(_vm._s(item.subkon_pic))]), _c('td', [_vm._v(_vm._s(item.subkon_pic_email))]), _c('td', [_vm._v(_vm._s(item.subkon_pic_phone))]), _c('td', [_vm._v(_vm._s(_vm.formatCurrency(item.subkon_price_deal)))]), _c('td', {
      staticClass: "td-attach"
    }, [_c('div', {
      staticClass: "attac-style-wrap"
    }, _vm._l(item.filePreview, function (url, i) {
      return _c('div', {
        key: "".concat(index, "-").concat(i),
        staticClass: "attac-style"
      }, [_c('AttachmentSR', {
        attrs: {
          "isPreview": true,
          "modelId": item.id,
          "modelName": "sr_form_repair_entity",
          "file": url
        },
        on: {
          "delete": function _delete($event) {
            return _vm.handleDeleteFile(item, i);
          }
        }
      })], 1);
    }), 0)]), _c('td', {
      staticClass: "td-remark"
    }, [_vm._v(_vm._s(item.subkon_notes))]), _vm.createAble ? _c('td', {
      staticClass: "p-2 d-flex"
    }, [_c('b-button', {
      staticClass: "mr-2",
      attrs: {
        "variant": "outline-primary",
        "size": "sm"
      },
      on: {
        "click": function click($event) {
          return _vm.$emit('onDelete', index);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash m-0"
    })]), _c('b-button', {
      attrs: {
        "variant": "outline-success",
        "size": "sm"
      },
      on: {
        "click": function click() {
          return _vm.handleEdit(item, index);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit m-0"
    })])], 1) : _vm._e()]);
  }), 0)])])]), !((_vm$data = _vm.data) !== null && _vm$data !== void 0 && _vm$data.length) ? _c('div', {
    staticClass: "p-3 d-flex justify-content-center w-100"
  }, [_c('img', {
    attrs: {
      "src": require('@/public/img/not-found-image.png'),
      "alt": "not-found-image",
      "width": "160",
      "height": "140"
    }
  })]) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }